import React from "react" 

import skillsInfo from "../skills.js"
import { Link } from "react-router-dom";

export default function Card(props ) 
{
    return (
        <div className="contacts">
            <div className="contact-card">

                {/* <img src={props.img} className="card--image" /> */}


                <h3> {props.title} </h3>

                <div className="info-group">
                     {/* <span className="gray">({props.highlightSkill}) • </span> */}
                </div>

                {/* <p> {props.title} </p> */}
                {/* <p><span className="bold">short decription: </span> </p> */}
                <p>{props.summary}  </p>


                {/* projInfo.liveDemoLink!="" ? 
                            <a className="skillTab" href={projInfo.liveDemoLink}  target="_blank" >
                            Live Demo
                            </a> : null */}

                {
                props.pageLink!="" ?
                <Link to={props.pageLink}>
                <p className="demoButton"><span >  Details </span> </p>                
                </Link>: null
                }                             





            </div>
        </div>
    )
}   


export function SkillsList() 
{
    const testSkill = skillsInfo.map( (skillInfo, index0) => 
        {            
            const skillList = skillInfo.skillList.split(",").map(skill => skill.trim());

            if (index0 == 0)
            {
                const libList = skillInfo.libraries.split(",").map(skill => skill.trim());
                const devList = skillInfo.devPlatforms.split(",").map(skill => skill.trim());
                const researchList = skillInfo.researchArea.split(",").map(skill => skill.trim());

                return  (                    
                    <div key={index0}>
                    <h2 > {skillInfo.title} </h2>
                    <h3 > {skillInfo.title2} </h3>
                    <p >
                            {
                                skillList.map((skill, index) => 
                                {
                                    return(
                                        <p key={index} className="skillTab">  {skill}  </p>                                                 
                                        );
                                } )
                            }                            
                    
                        </p>

                    <h3 > {skillInfo.title3} </h3>

                        <p >
                            {
                                libList.map((skill, index) => 
                                {
                                    return(
                                        <p key={index} className="skillTab">  {skill}  </p>                                                 
                                        );
                                } )
                            }                            
                    
                        </p>

                    <h3 > {skillInfo.title4} </h3>

                        <p >
                            {
                                devList.map((skill, index) => 
                                {
                                    return(
                                        <p key={index} className="skillTab">  {skill}  </p>                                                 
                                        );
                                } )
                            }                            
                    
                        </p>

                        <h3 > {skillInfo.title5} </h3>

                        <p >
                            {
                                researchList.map((skill, index) => 
                                {
                                    return(
                                        <p key={index} className="skillTab">  {skill}  </p>                                                 
                                        );
                                } )
                            }                            
                    
                        </p>                        



                    </div>

             
                );

            }
            else{

                return  (                    
                    <div key={index0}>
                    <h2 > {skillInfo.title} </h2>

                        <p >
                            {
                                skillList.map((skill, index) => 
                                {
                                    return(
                                        <p key={index} className="skillTab">  {skill}  </p>                                                 
                                        );
                                } )
                            }                            
                    
                        </p>
                    </div>

             
                );

            }


        } ); 
 
    return (
        testSkill

    )
}   